module.exports = __webpack_public_path__ + "48b31df4d97f4f89913853a1f2bb9eeb.svg";